<div class="container">
    <div class="header">
        <div class="text-header">
            <span class="mr-12" *ngIf="(isTablet$ | async) || (isMobile$ | async)">
                <app-button
                        [buttonClass]="'only-icon-light-gray'"
                        [iconDirection]="'left'"
                        [icon]="'assets/images/new-design-icons/close-white.svg'"
                        (buttonClick)="closeDialog()"/>
            </span>
            <span>Фильтр</span>
        </div>
        <app-button
            *ngIf="!(isTablet$ | async) && !(isMobile$ | async); else clearTmp"
            [buttonClass]="'only-icon-light-gray'"
            [iconDirection]="'left'"
            [icon]="'assets/images/new-design-icons/close-white.svg'"
            (buttonClick)="closeDialog()"/>

        <ng-template #clearTmp>
            <app-button
                    [buttonClass]="'small-reset'"
                    [text]="'Сбросить'"
                    [iconDirection]="'left'"
                    [icon]="'assets/images/new-design-icons/Close (orange).svg'"
                    (buttonClick)="clearFilters()"
            />
        </ng-template>
    </div>

    <div class="divider"></div>

    <div class="content">
        <form class="filters" [formGroup]="form">
            <div class="filter mr-24">
                <label class="label">ID заявки</label>
                <div class="control">
                    <input
                        type="text"
                        formControlName="proposalId"
                        class="jurta-input proposal-input"
                        placeholder="ID заявки"
                        (change)="updateFilter('proposalId', $event)"
                    />
                </div>
            </div>
            <div class="filter mr-24">
                <label class="label">Тип сделки</label>
                <div class="control">
                    <app-select
                        [control]="form.get('dealType')"
                        [placeholder]="'Выберите тип'"
                        [bindValue]="'value'"
                        [bindLabel]="'label'"
                        [itemList]="dealTypes"
                        [clearable]="false"
                        [width]="(isTablet$ | async) || (isMobile$ | async) ? '100%' : '232px'"
                        (selected)="updateFilter('dealType', $event)">
                    </app-select>
                </div>
            </div>
            <div class="filter">
                <label class="label">Стоимость</label>
                <div class="control p-d-flex">
                    <input type="text" mask="separator" thousandSeparator=" "
                           class="jurta-input price-input mr-8"
                           formControlName="priceFrom"
                           placeholder="От" (change)="updateFilter('priceFrom', $event)">
                    <input type="text" mask="separator" thousandSeparator=" "
                           class="jurta-input price-input"
                           formControlName="priceTo"
                           placeholder="До" (change)="updateFilter('priceTo', $event)">
                </div>
            </div>
            <div class="filter mr-24 mt-24">
                <label class="label">Год постройки</label>
                <div class="control p-d-flex">
                    <input type="text" mask="separator" thousandSeparator=" "
                           class="jurta-input price-input mr-8"
                           formControlName="constructYearFrom"
                           placeholder="От" (change)="updateFilter('constructYearFrom', $event)">
                    <input type="text" mask="separator" thousandSeparator=" "
                           class="jurta-input price-input"
                           formControlName="constructYearTo"
                           placeholder="До" (change)="updateFilter('constructYearTo', $event)">
                </div>
            </div>

            <div class="filter mr-24 mt-24">
                <label class="label">Комнатность</label>
                <div class="control">
                    <app-button-picker
                       [selectedOptions]="currentRoominess$ | async"
                       [buttonWidth]="(isTablet$ | async) || (isMobile$ | async) ? '100%' : '42px'"
                       (selectedEvent)="updateFilter('roominess', $event)"
                    ></app-button-picker>
                </div>
            </div>

            <div class="filter mt-24">
                <label class="label">Площадь</label>
                <div class="control p-d-flex">
                    <input type="text" mask="separator" thousandSeparator=" "
                           class="jurta-input price-input mr-8"
                           formControlName="areaFrom"
                           placeholder="От" (change)="updateFilter('areaFrom', $event)">
                    <input type="text" mask="separator" thousandSeparator=" "
                           class="jurta-input price-input"
                           formControlName="areaTo"
                           placeholder="До" (change)="updateFilter('areaTo', $event)">
                </div>
            </div>

            <div class="filter mr-24 mt-24">
                <label class="label">Город</label>
                <div class="control">
                    <app-select
                        [control]="form.get('city')"
                        [loading]="cityListLoading$ | async"
                        [placeholder]="'Выберите город'"
                        [itemList]="(cityList$ | async)"
                        [clearable]="false"
                        [bindValue]="'value'"
                        [bindLabel]="'label'"
                        [width]="(isTablet$ | async) || (isMobile$ | async) ? '100%' : '232px'"
                        (selected)="onCitySelect($event)">
                    </app-select>
                </div>
            </div>

            <div class="filter mr-24 mt-24">
                <label class="label">Жилой комплекс</label>
                <div class="control">
                    <app-residential-complex-selector
                        [multiple]="true"
                        [control]="form.get('complex')"
                        [width]="(isTablet$ | async) || (isMobile$ | async) ? '100%' : '232px'">
                    </app-residential-complex-selector>
                </div>
            </div>

            <div class="filter mr-24 mt-24">
                <label class="label">Район</label>
                <div class="control">
                    <app-district-selector
                        [control]="form.get('district')"
                        [multiple]="true"
                        [width]="(isTablet$ | async) || (isMobile$ | async) ? '100%' : '232px'"
                    >
                    </app-district-selector>
                </div>
            </div>

            <div class="filter mr-24 mt-24">
                <label class="label">Улица</label>
                <div class="control">
                    <app-street-selector
                        [control]="form.get('street')"
                        [isDisabled]="!form.get('district').value"
                        [multiple]="true"
                        [width]="(isTablet$ | async) || (isMobile$ | async) ? '100%' : '232px'"
                    >
                    </app-street-selector>
                </div>
            </div>

            <div class="filter mr-24 mt-24">
                <label class="label">Планировка</label>
                <div class="control">
                    <app-select
                        [control]="form.get('layout')"
                        [placeholder]="'Выберите планировку'"
                        [bindValue]="'value'"
                        [bindLabel]="'label'"
                        [itemList]="layoutOptions"
                        [width]="(isTablet$ | async) || (isMobile$ | async) ? '100%' : '232px'"
                        (selected)="updateFilter('layout', $event)">
                    </app-select>
                </div>
            </div>

            <div class="filter mr-24 mt-24">
                <label class="label">Состояние</label>
                <div class="control">
                    <app-select
                        [control]="form.get('condition')"
                        [bindValue]="'value'"
                        [bindLabel]="'label'"
                        [placeholder]="'Любое'"
                        [itemList]="houseConditions$ | async"
                        [loading]="houseConditionsLoading$ | async"
                        (selected)="conditionSelect($event)"
                        [width]="(isTablet$ | async) || (isMobile$ | async) ? '100%' : '232px'"
                    >
                    </app-select>
                </div>
            </div>
        </form>
    </div>

    <div class="divider"></div>

    <div class="buttons">
        <div class="search-button" (click)="saveSearch()">
            <span class="mr-8"><img [src]="'assets/images/new-design-icons/search_gradient.svg'" alt="search"></span>
            <span>Сохранить поиск</span>
        </div>
        <div class="right-buttons">
            <div class="button mr-12" *ngIf="!(isTablet$ | async) && !(isMobile$ | async)">
                <app-button
                    [buttonClass]="'small-reset'"
                    [text]="'Сбросить'"
                    [iconDirection]="'left'"
                    [icon]="'assets/images/new-design-icons/Close (orange).svg'"
                    (buttonClick)="clearFilters()"
                />
            </div>
            <div class="button">
                <app-button
                    [buttonClass]="'small-purple-gradient'"
                    [text]="'Показать ' + (currentRealPropertyCount$ | async) + ' объектов'"
                    (buttonClick)="onSearch()"
                    [styleInline]="{ 'height': '100%' }"
                ></app-button>
            </div>
        </div>
    </div>

</div>
